import React, { useState } from 'react';
import { Sparkles, CheckCircle } from 'lucide-react';

const ScheduleForm = ({ onSchedule, onCancel }) => {
  const [formData, setFormData] = useState({
    recipientType: 'user',
    recipient: '',
    message: '',
    scheduleDate: '',
    scheduleTime: ''
  });

  const [errors, setErrors] = useState({});

  const recipientOptions = {
    user: ['Sarah Williams', 'John Doe', 'Mike Johnson', 'Emily Brown'],
    group: ['Project Alpha Team', 'Marketing Group', 'Development Team', 'Design Squad'],
    client: ['Acme Corp', 'TechStart Inc', 'Global Solutions', 'Innovate Labs']
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.recipient) {
      newErrors.recipient = 'Please select a recipient';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message cannot be empty';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    if (!formData.scheduleDate) {
      newErrors.scheduleDate = 'Please select a date';
    }

    if (!formData.scheduleTime) {
      newErrors.scheduleTime = 'Please select a time';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      // FIXED: Call onSchedule with the form data to send to parent
      onSchedule(formData);

      // Reset form
      setFormData({
        recipientType: 'user',
        recipient: '',
        message: '',
        scheduleDate: '',
        scheduleTime: ''
      });
    } else {
      setErrors(newErrors);
    }
  };

  // Get tomorrow's date for min date attribute
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minDate = tomorrow.toISOString().split('T')[0];

  return (
    <div className="schedule-form-container">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 shadow-2xl border-2 border-cyan-200">
        {/* Header */}
        <div className="form-header">
          <div className="header-icon-wrapper">
            <Sparkles className="header-icon" />
          </div>
          <h3 className="header-title">Schedule a Message</h3>
          {/* Optional: Add cancel button in header */}
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="cancel-button"
            >
              Cancel
            </button>
          )}
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="form-content">
          {/* Recipient Type and Recipient */}
          <div className="form-grid">
            <div className="form-field">
              <label className="field-label">
                Recipient Type
              </label>
              <select
                name="recipientType"
                value={formData.recipientType}
                onChange={handleChange}
                className="form-select-ScheduleForm"
              >
                <option value="user">User</option>
                <option value="group">Group</option>
                <option value="client">Client</option>
              </select>
            </div>

            <div className="form-field">
              <label className="field-label">
                Recipient
              </label>
              <select
                name="recipient"
                value={formData.recipient}
                onChange={handleChange}
                className={`form-select-ScheduleForm ${errors.recipient ? 'error' : ''}`}
              >
                <option value="">Select recipient</option>
                {recipientOptions[formData.recipientType]?.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {errors.recipient && (
                <span className="error-message">{errors.recipient}</span>
              )}
            </div>
          </div>

          {/* Message */}
          <div className="form-field">
            <label className="field-label">
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Type your message here..."
              rows="4"
              className={`form-textarea-ScheduleForm ${errors.message ? 'error' : ''}`}
            />
            {errors.message && (
              <span className="error-message">{errors.message}</span>
            )}
            <div className="character-count">
              {formData.message.length}/500 characters
            </div>
          </div>

          {/* Schedule Date and Time */}
          <div className="form-grid">
            <div className="form-field">
              <label className="field-label">
                Schedule Date
              </label>
              <input
                type="date"
                name="scheduleDate"
                value={formData.scheduleDate}
                onChange={handleChange}
                min={minDate}
                className={`form-input-ScheduleForm ${errors.scheduleDate ? 'error' : ''}`}
              />
              {errors.scheduleDate && (
                <span className="error-message">{errors.scheduleDate}what is this</span>
              )}
            </div>

            <div className="form-field">
              <label className="field-label">
                Schedule Time
              </label>
              <input
                type="time"
                name="scheduleTime"
                value={formData.scheduleTime}
                onChange={handleChange}
                className={`form-input-ScheduleForm ${errors.scheduleTime ? 'error' : ''}`}
              />
              {errors.scheduleTime && (
                <span className="error-message">{errors.scheduleTime}</span>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="submit-button-ScheduleForm"
          >
            <CheckCircle className="button-icon" />
            Schedule Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ScheduleForm;